var btn = $(".booking #btnSubmit");
  btn.on('click', function() {
  	var form = $(".booking form");
    $(this).prop("disabled", true);
    $.ajax({
      "type": "POST",
      url: "https://booking.magentify.net/appointment/book?" + form.serialize() + "&store_domain="+window.location.href,
      beforeSend: function() {
      	btn.text("Booking....");
      },
      success: function(res) {
        var messageContainer = $(".booking .form-message");
        if (res.success) {
        	btn.text("Booked");
          	setTimeout(btn.text("Book"), 2000);
          	messageContainer.empty();
          	window.location.href = '/pages/appointment-has-been-booked';
        } else {
          
          messageContainer.empty();
          var messages = "";
          for(var i = 0; i < res.message.length; i++) {
          	messages += "<p>"+res.message[i]+"</p>";
          }
          messageContainer.html(messages);
        }
        btn.text("Book");
        btn.prop("disabled", false);
      },
      error: function() {
      	btn.text("Failed");
        btn.prop("disabled", false);
        setTimeout(btn.text("Book"), 1000);
      }
    
    });
  });